import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/transporte-paciente`

    const headers = { responseType: "arraybuffer" }

    return {
        listagemAgendados(queryParms = {}) {
            return repository.get(`${baseUrl}/listagem-agendados?${urlUtil.serialize(queryParms)}`, headers)
        },
        listagemAgendadosSimples(queryParms = {}) {
            return repository.get(`${baseUrl}/listagem-agendados-simples?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAgendador(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-agendador?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAgendadorCompleto(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-agendador-completo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioViagem(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-viagem?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstatistico(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-estatistico?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativo(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-quantitativo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioViagemVeiculo(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-viagem-veiculo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioViagemMotorista(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-viagem-motorista?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioViagemGeral(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-viagem-geral?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioViagemData(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-viagem-data?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPrestacaoConta(queryParms = {}) {
            return repository.get(`${baseUrl}/relatorio-prestacao-conta?${urlUtil.serialize(queryParms)}`, headers)
        }
    }
}
